// extracted by mini-css-extract-plugin
export var component = "PostsModuleFilterForm-module--component--ik4c0";